import type { PipeTransform } from '@angular/core';
import { inject, Pipe } from '@angular/core';
import { ServerTimeService } from '../../core/server-time.service';
import { isNil } from '@pct/ts-typeguard';
import dayjs from 'dayjs';

@Pipe({ name: 'serverDateTime' })
export class ServerDateTimePipe implements PipeTransform {
  private readonly tz = inject(ServerTimeService).serverTimeZone;

  transform(value: string | Date | null | undefined, format = 'YYYY-MM-DD HH:mm'): string {
    if (isNil(value)) return '';
    return dayjs.utc(value).tz(this.tz()).format(format);
  }
}
